// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vRgwa","content":"styles_content__Lxc37"};